<!--
<app-notifications></app-notifications>
-->

<section class="content">
  <h1>Belege</h1>
  <mat-stepper linear #stepper labelPosition="bottom">
    <ng-template matStepperIcon="edit">
      <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">edit</mat-icon>
    </ng-template>
    <form [formGroup]="searchForm" id="searchForm">
      <mat-step label="Belegart/Zeitraum" class="px-0">
        <div class="d-flex jcsb">
          <div class="doc-types">
            @if (docTypeLoading) {
              <mat-spinner [diameter]="50"></mat-spinner>
            }
            <h4>Belegartliste</h4>
            @if (!docTypeLoading) {
              <mat-radio-group
                aria-labelledby="Belegartliste"
                class="d-flex flex-column"
                formControlName="docType"
              >
                @for (docType of docTypes; track docType) {
                  <mat-radio-button value="{{docType.attribute}}"
                                    (change)="setDocType($event)">{{docType.value}}</mat-radio-button>
                }
              </mat-radio-group>
            }
            @if (!selectedType) {
              <mat-error>Bitte wählen Sie ein Belegtyp</mat-error>
            }
          </div>
          @if (showDocNr || showPzn) {
            <div class="advanced-search d-flex flex-column">
              <h3>Erweiterte Suche</h3>
              @if (showDocNr) {
                <mat-form-field appearance="outline" class="mt-s">
                  <mat-label>Belegnummer</mat-label>
                  <input matInput formControlName="docNr">
                </mat-form-field>
              }
              @if (showPzn) {
                <mat-form-field appearance="outline" class="mt-s">
                  <mat-label>PZN Nummer (bis einschließlich Vortag)</mat-label>
                  <input matInput formControlName="pzn" [matAutocomplete]="auto" (input)="autosearch($event)">
                </mat-form-field>
              }
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="openProduct($event.option.value)">
                @for (product of products; track product) {
                  <mat-option [value]="product.pzn+' '+product.name">
                    {{ product.pzn }} {{ product.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </div>
          }
          <div class="time w-40">
            <div class="d-flex flex-column jcc by-months mb-m">
              <h3>Belege nach Monat</h3>
              <mat-card class="calendar-card ">
                <mat-card-content class="months">
                  @for (month of months; track month) {
                    <button mat-button type="button"
                            color = "{{(selectedMonth === month) ? 'primary' : 'neutral'}}"
                            (click)="selectedMonth = month; setDateRange(month, stepper)"
                            class="mr-s mb-s">{{month | date: 'MMMM yyyy'}}</button>
                  }
                </mat-card-content>
              </mat-card>

              @if (show12Months()) {
                <button mat-stroked-button type="button"
                        (click)="selectedMonth = 'all'; setDateRange('all', stepper)"
                        color = "{{(selectedMonth === 'all') ? 'primary' : 'secondary'}}"
                        class="mt-l">
                  Alle Belege der letzte 12 Monate
                </button>
              }
            </div>
            @if (!show12Months()) {
              <div class="w-100 d-flex flex-column">
                <div class="defined-dates">
                  <h3>Belege nach vordefinierten Zeiträumen</h3>
                  <div class="d-flex jcsb mb-m">
                    <mat-button-toggle-group aria-label="Vordefinierte Zeiträumen">
                      <mat-button-toggle (click)="setToday(); $event.stopPropagation(); $event.preventDefault()">Heute</mat-button-toggle>
                      <mat-button-toggle (click)="setLastWeek(); $event.stopPropagation(); $event.preventDefault()">Letzte 7 Tage</mat-button-toggle>
                      <mat-button-toggle (click)="setLastMonth(); $event.stopPropagation(); $event.preventDefault()">Letzte 30 Tage</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div>
                  <h3>Belege nach genauen Zeitraum</h3>
                  <div class="d-flex flex-column">
                    <mat-form-field class="mr-s">
                      <input matInput [matDatepicker]="picker1" placeholder="Start Date" formControlName="startDate"
                             (dateChange)="setStartDate($event)">
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker2" placeholder="End Date" (dateChange)="setEndDate($event)"
                             formControlName="endDate">
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            }
            @if (!(searchForm.get('startDate')?.value || searchForm.get('endDate')?.value)) {
              <mat-error>Bitte wählen Sie den Zeitraum für die Suche aus.</mat-error>
            }
          </div>
        </div>
        <div class="my-m">
          <!--        <button mat-button matStepperPrevious type="button" (click)="$event.stopPropagation(); $event.preventDefault()">-->
          <!--          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">arrow_back</mat-icon> Zurück-->
          <!--        </button>-->
          <button mat-button matStepperNext type="button" (click)="search($event);showTable = true"
                  [disabled]="!this.searchForm.valid">Weiter <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">arrow_forward</mat-icon></button>
        </div>
      </mat-step>
    </form>
    <mat-step label="Ergebnisse zu Ihrer Belegsuche" class="px-0">
      <div class="my-m">
        <button mat-flat-button matStepperPrevious type="button" (click)="backAStep(stepper)" class="mr-m mb-m"><mat-icon fontSet="material-symbols-outlined" aria-hidden="false">arrow_back</mat-icon>
          Zurück
        </button>
        <button mat-flat-button
                (click)="stepper.reset(); resetSteps();$event.stopPropagation(); $event.preventDefault(); documents = []; docs = []" type="button"
                class="mb-m">
          Reset <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">restart_alt</mat-icon>
        </button>
        <app-invoices-results [documents]="docs"></app-invoices-results>
      </div>
    </mat-step>
  </mat-stepper>
</section>
